export const containsUserType = (currentUserTypeId, ...userTypes) => {
  return userTypes.some((userType) => userType === currentUserTypeId);
};
